"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(client) {
    return {
        actOnCampaign: function (campaignId, action, data) {
            if (data === void 0) { data = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.post("/campaigns/" + campaignId + "/actions/" + action, data)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getCampaigns: function (status, params) {
            if (status === void 0) { status = 'sent'; }
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("campaigns/" + status, { params: params })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getCampaignCount: function (status) {
            if (status === void 0) { status = 'sent'; }
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("campaigns/" + status + "/count")];
                        case 1:
                            count = (_a.sent()).count;
                            return [2 /*return*/, count];
                    }
                });
            });
        },
        createCampaign: function (campaign) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!campaign.groups && !campaign.segments) {
                                throw new Error('Groups or segments have to be specified');
                            }
                            if (campaign.type === 'regular' && !campaign.subject) {
                                throw new Error('Mail subject is required if campaign type is regular.');
                            }
                            if (campaign.type === 'ab' && !campaign.abSettings && typeof campaign.abSettings !== 'object') {
                                throw new Error('AbSettings are required if campaign type is ab.');
                            }
                            return [4 /*yield*/, client.post('campaigns', campaign)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        removeCampaign: function (campaignId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.delete("campaigns/" + campaignId)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        setCampaignContent: function (campaignId, content) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.put("campaigns/" + campaignId + "/content", content)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
    };
}
exports.default = default_1;
